// components/styles.ts
import { keyframes } from '@mui/system';
import { styled } from '@mui/material';

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Styles = {
  LoadingContainer: styled('div')<{ showOverlay: boolean }>(
    ({ showOverlay }) => ({
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: showOverlay ? 'rgba(255, 255, 255, 0.7)' : 'transparent',
      zIndex: 9999
    })
  ),

  Spinner: styled('div')(({ theme }) => ({
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    border: '5px solid #f3f3f3',
    borderTop: '5px solid #105330',
    animation: `${spin} 1s linear infinite`
  }))
};
